'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const isUndefined = (value) => (value === undefined);

exports.isUndefined = isUndefined;
//# sourceMappingURL=is-undefined.js.map
